// APULKI TEST (SIT)
// export const PACS_API = 'https://apisix.techjivaaindia.in/api//api/';
// export const MASTER_API = 'https://apisix.techjivaaindia.in/api/';
// export const AUTH_TOKEN_API = 'https://apisix.techjivaaindia.in/api/userManagement/authentication/getTokenByUserName/';
// export const GET_STAFF_INFO = 'https://apisix.techjivaaindia.in/api/masterMgmt/mstStaff/byId/';
// export const FULL_SCREEN_REPORT = `${MASTER_API}test_server/`;
// export const SHARE_LINK = 'https://viewer.techjivaaindia.in/';


// APULKI PRODUCTION (UAT)
// export const PACS_API = 'https://hims.apulkihealthcare.com/api/';   // old uat api
// export const PACS_API = 'https://api.apulkihealthcare.com/api/api/';
// export const MASTER_API = 'https://api.apulkihealthcare.com/api/';
// export const AUTH_TOKEN_API = 'https://api.apulkihealthcare.com/api/userManagement/authentication/getTokenByUserName/';
// export const GET_STAFF_INFO = 'https://api.apulkihealthcare.com/api/masterMgmt/mstStaff/byId/';
// export const FULL_SCREEN_REPORT = `${MASTER_API}uat_server/`;
// export const SHARE_LINK = 'https://viewer.apulkihealthcare.com/';


// APULKI PRODUCTION (LIVE)
// export const PACS_API = 'https://apisix.apulkihealthcare.in/api/api/';
// export const MASTER_API = 'https://apisix.apulkihealthcare.in/api/';
// export const AUTH_TOKEN_API = 'https://apisix.apulkihealthcare.in/api/userManagement/authentication/getTokenByUserName/';
// export const GET_STAFF_INFO = 'https://apisix.apulkihealthcare.in/api/masterMgmt/mstStaff/byId/';
// export const FULL_SCREEN_REPORT = `${MASTER_API}live_server/`;
// export const SHARE_LINK = 'http://pacsviewer.apulkihealthcare.in/';


// TECHJIVAA
// export const PACS_API = 'https://services.techjivaaindia.in/api/';
// export const MASTER_API = 'https://services.techjivaaindia.in/';
// export const AUTH_TOKEN_API = 'https://services.techjivaaindia.in/userManagement/authentication/getTokenByUserName/';
// export const GET_STAFF_INFO = 'https://services.techjivaaindia.in/masterMgmt/mstStaff/byId/';
// export const FULL_SCREEN_REPORT = `${MASTER_API}sainath_and_karnataka_client/`;


// EHMIS
// export const PACS_API = 'https://ehmis.medimaze.in/api/';
// export const MASTER_API = 'https://ehmis.medimaze.in/';
// export const AUTH_TOKEN_API = 'https://ehmis.medimaze.in/userManagement/authentication/getTokenByUserName/';
// export const GET_STAFF_INFO = 'https://ehmis.medimaze.in/masterMgmt/mstStaff/byId/';
// export const FULL_SCREEN_REPORT = `${MASTER_API}bilasa_client/`;


// KRSNAA DIAGNOSTIC
// export const PACS_API = 'https://ris.krsnaadiagnostics.com/api/';
// export const MASTER_API = 'https://ris.krsnaadiagnostics.com/';
// export const AUTH_TOKEN_API = 'https://ris.krsnaadiagnostics.com/userManagement/authentication/getTokenByUserName/';
// export const GET_STAFF_INFO = 'https://ris.krsnaadiagnostics.com/masterMgmt/mstStaff/byId/';
// export const FULL_SCREEN_REPORT = `${MASTER_API}krsnaa_client/`;
// export const SHARE_LINK = 'https://viewer.krsnaadiagnostics.com/';


// NIGERIA
export const PACS_API = 'https://ris.clinixhealthcare.com.ng/api/';
export const MASTER_API = 'https://ris.clinixhealthcare.com.ng/';
export const AUTH_TOKEN_API = 'https://ris.clinixhealthcare.com.ng/userManagement/authentication/getTokenByUserName/';
export const GET_STAFF_INFO = 'https://ris.clinixhealthcare.com.ng/masterMgmt/mstStaff/byId/';
export const FULL_SCREEN_REPORT = `${MASTER_API}nigeria_client/`;
export const SHARE_LINK = 'https://viewer.clinixhealthcare.com.ng/';


// KARNATAKA
// export const PACS_API = 'https://apikarnataka.medimaze.in/api//api/';
// export const MASTER_API = 'https://apikarnataka.medimaze.in/api/';
// export const AUTH_TOKEN_API = 'https://apikarnataka.medimaze.in/userManagement/authentication/getTokenByUserName/';
// export const GET_STAFF_INFO = 'https://apikarnataka.medimaze.in/api/masterMgmt/mstStaff/byId/';
// export const FULL_SCREEN_REPORT = `${MASTER_API}karnataka_client/`;
// export const SHARE_LINK = 'https://viewer.karnatakapacs.medimaze.in/';


// get prohibited keywords
export const BLOCKED_KEYWORDS = `${MASTER_API}/api/prohibited_words/getbygender?phGender=`;


// Voice Command Backend API
// export const VOICE_COMMAND_API = 'http://localhost:8096/api/voice-command/';
export const VOICE_COMMAND_API = `${MASTER_API}/voice-command/`;

// Alternative: Use production backend when deployed
// export const VOICE_COMMAND_API = 'https://your-backend-domain.com/api/voice-command/';


// DCM4CHEE LINKS FOR ALL CLIENTS
// TEST SERVER    : https://pacs.techjivaaindia.in/dcm4chee-arc/ui2/en/study/study
// KRSNAA CLIENT  : https://ris.krsnaadiagnostics.com/dcm4chee-arc/ui2/en/study/study
// NIGERIA CLIENT : https://ris.clinixhealthcare.com.ng/dcm4chee-arc/ui2/en/study/study
// EHMIS          : https://epacs.medimaze.in/dcm4chee-arc/ui2/en/study/study
// MEDIMAZE PACS  : http://103.235.68.37:8085/dcm4chee-arc/ui2/en/study/study
// APULKI-UAT     : https://pacs.apulkihealthcare.com/dcm4chee-arc/ui2/en/study/study
// APLUKI-LIVE    : https://ris.apulkihealthcare.in/dcm4chee-arc/ui2/en/study/study
